function checkOrientation() {
	if($("body").hasClass('mobile') && $(window).width() < $(window).height()){
		return true;
	}
}

function setClass(param) {
	if(param && $("body").hasClass('mobile') ){
		$("body").addClass("off");
		$("body").removeClass("on");
	} else {
		$("body").addClass("on");
		$("body").removeClass("off");
	}
}

$(window).on('orientationchange', function () {
	location.reload();
});


/** - Window on load ----------------------------------------------------------------------------------------------- **/

$(window).load(function () {
	if(checkOrientation() || $("body").hasClass("desktop") || $("body").hasClass("tablet")) {
		teamfilter.init();
	}

	setClass(checkOrientation());
});


/** - Document on ready --------------------------------------------------------------------------------------------- **/
$(document).ready(function () {
	if(checkOrientation() || $("body").hasClass("desktop") || $("body").hasClass("tablet")) {
		helpers.init();

		$('body').attr('style', '');

		$(".teaser__arrow").on("click", function (e) {
			e.preventDefault();
			helpers.scrollSetup('#lead__container');
		});


		$(".lead__link a").on("click", function (e) {
			e.preventDefault();
			helpers.scrollSetup("#product__container");
		});


		if ($("body").hasClass("page_6")) {
			newsFunctions.init();
		};
	}

	setClass(checkOrientation());
});


/** - Window on scroll --------------------------------------------------------------------------------------------- **/

$(window).scroll(function () {
});


/** - Helpers ------------------------------------------------------------------------------------------------------ **/

var helpers = {
    init: function () {
        this.relExternal();
        this.swiperSetup();
        this.phoneAnimation();
        this.navMobile();
        this.borderWidth();
    },

    relExternal: function () {
        $(document).on("click", "a[rel=external]", function (e) {
            e.preventDefault();
            window.open($(this).attr("href"), "_blank");
        });
    },

    swiperSetup: function() {
        var swiper = new Swiper('.swiper__container-right', {
          pagination: {
            el: '.swiper-pagination',
            type: 'fraction'
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          }
        });
    },

    scrollSetup: function (element) {
        var scrollAnchor = element;
        var scrollPoint = $(scrollAnchor).offset().top;

        $('body,html').animate({
            scrollTop: scrollPoint
        }, 500);

        return false;
    },

    phoneAnimation: function () {
        $(".global-phone-icon").click(function () {
            $('.global-phone-icon').toggleClass('show');
        });

        return false;
    },

	navMobile: function () {
    	var activeValue = false;
		$('.hamburger__3dx').on("click", function(e) {
			$(this).toggleClass("is-active");

			if($(".navigation__main").hasClass("show")){
				$(".content, .footer").removeClass("hide");
			} else {
				setTimeout(function () {
					$(".content, .footer").addClass("hide");
				}, 351);
			}

			$('.navigation__main').toggleClass("show");
			$('.navigation__lang').toggleClass("show");
			 //$("html, body").css("overflow", "hidden");
			 //$("body").css("height", "100%");

			//$(".navigation__mobile-closed").toggleClass("open");
			//$(".navigation__mobile-open").toggleClass("closed");
			$("body").toggleClass("overflow");


			var tl = anime.timeline({
				duration: 350,
				easing: 'cubicBezier(1.000, 0.005, 0.000, 1.505)'
			});

			var tl2 = anime.timeline({
				duration: 350,
				easing: 'cubicBezier(1.000, 0.005, 0.000, 1.505)'
			});

			if(activeValue) {
				activeValue = false;

				tl.add({
					targets: ".navigation__mobile-closed",
					right: ["100px", "80px"],
					opacity: [1, 0],
					//offset: '+=10',
				});

				tl.add({
					targets: ".navigation__mobile-open",
					right: ["140px", "80px"],
					opacity: [0, 1],
					//offset: '-=1350',
				});
			} else {
				activeValue = true;

				tl2.add({
					targets: ".navigation__mobile-open",
					right: ["100px", "80px"],
					opacity: [1, 0],

				});

				tl2.add({
					targets: ".navigation__mobile-closed",
					right: ["140px", "80px"],
					opacity: [0, 1],
					//offset: '+=10',
				});
			}

		});
	},


	borderWidth: function () {
		if($("body").hasClass('mobile')){
			var getInnerWidth= $(".text_namepos .name").width() + $(".text_namepos .position").width() + 20;
			var getParentWidth = $(".text_namepos").width();

			if($(window).width() > 330){
				var offset = 80;
			} else {
				offset = 40
			}
			var maxWidth = getParentWidth - offset;

			if(getInnerWidth > maxWidth){
				$(".text_namepos").addClass('hide__border');
			} else {
				$(".text_namepos").removeClass('hide__border');
			}
		}
	}
};

/*******************************************************************
 FILTER FOR TEAM
 *******************************************************************/
var teamfilter = {
    init: function (data) {
        this.getIsotope(data);
    },
    getIsotope: function (data) {
        if ($('.team__divisions').length > 0) {

	/*		if ($(window).width() <= 768) {
				var gutterWidth = 40;
			} else if ($(window).width() <= 1230) {
					gutterWidth = 40;
			} else {
				gutterWidth = 40;
			}*/

			var gutterWidth = 40;

            // init Isotope
            var $grid = $('.team__container').isotope({
                itemSelector: '.element-item',
                layoutMode: 'fitRows',
				fitRows: {
					gutter: gutterWidth,
					isFitWidth: true
				}
            });

            // bind filter on select change
            $('.team__divisions').on('change', function () {
                //console.log('on change isotope');
                var filterValue = this.value;
                //console.log('value ',filterValue);
                filterValue = '.division__' + filterValue;
                // select all employes
                if(filterValue == '.division__0') {
                    filterValue = '*';
                }
                //console.log('filter: ', filterValue);
                $grid.isotope({filter: filterValue});
            });
		}
    }
};


/*******************************************************************
 SHOW ALL NEWS WITH AJAX
 *******************************************************************/


var newsFunctions = {

    init: function () {
        this.showAllNewsAjax()
    },
    showAllNewsAjax: function () {

        $data = null;

        $(".btn.loadmore").on("click", function (e) {
            e.preventDefault();

            $data = jQuery.parseJSON($(this).attr("data-informations"));
            newsFunctions.getAjaxCall($data, $(this).attr("data-load"));
        });

        $(".btn.loadless").on("click", function (e) {
            e.preventDefault();

            $data = jQuery.parseJSON($(this).attr("data-informations"));
            newsFunctions.getAjaxCall($data, $(this).attr("data-load"));
        });

    },
    getAjaxCall: function (data, dataKey) {

        if(dataKey == 'more') {
            $('.loadmore').css("display", 'none');
            $('.loadless').css("display", 'inline-block');
        } else {
            $('.loadmore').css("display", 'inline-block');
            $('.loadless').css("display", 'none');
        }

        $('.news__container-wrapper').html('<div class="ajaxloader"><img class="ajaxloader__img" src="/media/ajax-loader.gif" /></div>');

        var count = 0;
        if(dataKey == "more") {
            count = data.currentCount;
        } else {
            count = data.maxCount;
        }

        var saveData = $.ajax({
            type: 'POST',
            url: "index.php?rex-api-call=loadallnews",
            dataType: 'text',
            data: {
                articles : data.articles,
                count : count,
                lang : data.currentLanguage
            },
            success: function(resultData) {
                $('.news__container-wrapper').html(resultData);
            }
            //saveData.error(function() { alert("error"); });
        });
    }
};


